import React, { useState, useCallback, useEffect } from "react";
import useStyles from "./style";
import { Button, Grid, Typography } from "@mui/material";
import { DeleteOutline } from "@mui/icons-material";
import { ContentCopyOutlined, TableChartOutlined, DescriptionOutlined, PictureAsPdfOutlined } from "@mui/icons-material";
import { DataGrid  } from "@mui/x-data-grid";
import * as XLSX from "xlsx";
import Papa from "papaparse";
import jsPDF from "jspdf";
import "jspdf-autotable";

import { showLoader, hideLoader } from "Redux/Loader/actions";
import { showSnackbar } from "Redux/SnackBar/actions";
import { useDispatch } from "react-redux";
import _ from "lodash";

//Services
import CorporateApi from "Services/Corporate";

//Modals
import CorporateAddModal from "Pages/Modals/Corporate/Create";
import CorporateUpdateModal from "Pages/Modals/Corporate/Update";
import CorporateDeleteDialog from "Pages/Modals/Corporate/Delete";

const Corporate = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [row, setRow] = useState([]);
  const [customerId, setCustomerId] = useState("");

  //Pagination

  const [page, setPage] = useState(1); // Initial page number
  const [pageSize, setPageSize] = useState(5); // Initial page size
  const [totalPages, setTotalPages] = useState(1);

  //Modals

  const [addCorporateModal, setcorporateModal] = useState(false);
  
  const handleOpenAddCorporateModal = () => {
    setcorporateModal(true);
  };

  const handleCloseAddCorporateModal = () => {
    setcorporateModal(false);
    getCorporate();
  };

  const [updateCorporateModal, setUpdateCorporateModal] = useState(false);

  const handleOpenCorporateModal = (row) => {
    setCustomerId(row?._id);
    setUpdateCorporateModal(true);
  };

  const handleCloseCorporateModal = () => {
    setUpdateCorporateModal(false);
    getCorporate();
  };

  const [deleteCorporateModal, setdeleteCorporateModal] = useState(false);

  const handleOpenDeleteCorporateModal = (row) => {
    setCustomerId(row?._id);
    setdeleteCorporateModal(true);
  };

  const handleCloseDeleteCorporateModal = (row) => {
    setdeleteCorporateModal(false);
    getCorporate();
  };

  // Get Passenger list api
  const getCorporate = useCallback(() => {
    dispatch(showLoader("Loading please wait..."));
    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.data?.status === true) {
        console.log('corporate datas --->',res.data);
        setTotalPages(res?.data?.data?.totalRecords || 1);
        setRow(res?.data?.data?.data);
      } else {
        setRow([]);
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || "Failed to fetch data",
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
      //console.log("error fetch service area", err);
    };
    CorporateApi
      .getCorporateList({ page, limit: pageSize })
      .then(onSuccess, onFailure);
  }, [dispatch, page, pageSize]);

  useEffect(() => {
    getCorporate();
  }, [getCorporate]);
 
  const handlePageChange = (newPage) => {
    let theNewPage = parseInt(newPage) + 1;
    if (theNewPage >= 1) {
      setPage(theNewPage);
    }
  };

  const handleCopy = () => {
      // Define column widths
      const columnWidths = [5, 15, 25, 15, 15 , 15 , 15]; // Adjust widths as needed
  
      // Helper function to pad text to the desired width
      const padText = (text, width) => {
        return (text ?? "").toString().padEnd(width, " ");
      };
      // Create table header

      const header = [
        padText("S.NO", columnWidths[0]),
        padText("Legal Name", columnWidths[1]),
        padText("Display Name", columnWidths[2]),
        padText("Email", columnWidths[3]),
        padText("Secondary Email", columnWidths[4]),
        padText("Mobile", columnWidths[5]),
        padText("Status", columnWidths[6])        
      ].join("");
  
      // Create table rows
      const rows = dataRows
        .map((row) =>
          [
            padText(row.sno, columnWidths[0]),
            padText(row.firstName, columnWidths[1]),
            padText(row.displayName, columnWidths[2]),
            padText(row.email, columnWidths[3]),
            padText(row.secondaryEmail, columnWidths[4]),            
            padText(row.mobile, columnWidths[5]),
            padText(row.status, columnWidths[6])
          ].join("")
        )
        .join("\n");
    
      // Combine header and rows
      const formattedContent = [header, rows].join("\n");
    
      // Copy to clipboard
      navigator.clipboard.writeText(formattedContent).then(() => {
        alert("Table copied to clipboard!");
      });
  };

  const handleDownloadExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet(formatteddatas);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Services");
    XLSX.writeFile(workbook, "Corporate.xlsx");
  };

  const handleDownloadCSV = () => {
    const csv = Papa.unparse(formatteddatas);
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "Corporate.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleDownloadPDF = () => {
    const doc = new jsPDF();     
    const tableData = dataRows.map((row) => [
      row.sno,
      row.firstName,
      row.displayName,
      row.email,
      row.secondaryEmail,
      row.mobile,
      row.status
    ]);

    doc.autoTable({
      head: [["S.NO","Legal Name","Display Name","Email","Secondary Email","Mobile","Status"]],
      body: tableData,
    });
    doc.save("Corporate.pdf");
  };

  const calculateSno = (pageIndex, pageSize, index) => {
    return (pageIndex - 1) * pageSize + index + 1;
  };

  const dataRows = _.map(row || [], (data, index) => {
    const serviceTypeLabel =
      data?.corporateDetails?.serviceType?.serviceName ||
      data?.corporateDetails?.serviceType?.name ||
      data?.serviceType?.serviceName ||
      data?.serviceType?.name ||
      data?.service_type?.serviceName ||
      data?.service_type?.name ||
      data?.corporateDetails?.accountStatus ||
      "";

    const statusLabel = data?.status || (data?.isActive === 1 ? "Active" : "Inactive");
    const normalizedStatus = serviceTypeLabel.toString().toUpperCase();
    const documentsServiceType = serviceTypeLabel ;
 
    const documentsServiceTypeBackground = normalizedStatus === "ACTIVE" || normalizedStatus === "APPROVED"
      ? "#34ab4d"
      : normalizedStatus === "INACTIVE" || normalizedStatus === "BANNED"
      ? "#f44336"
      : "#FB8C00";
    const statusBackground =
      normalizedStatus === "ACTIVE" || normalizedStatus === "APPROVED"
        ? "#34ab4d"
        : normalizedStatus === "INACTIVE" || normalizedStatus === "BANNED"
        ? "#f44336"
        : "#FB8C00";

    return {
      sno: calculateSno(page, pageSize, index),
      firstName: data?.firstName,
      displayName: data?.corporateDetails?.displayName,
      email: data?.email,
      secondaryEmail: data?.corporateDetails?.secondaryEmail,
      mobile: data?.mobileNumber,
      panNumber: data?.corporateDetails?.panNumber,
      documentsServiceType,
      documentsServiceTypeBackground,
      status: statusLabel,
      background: statusBackground,
      row: data,
    };
  });

  const formatteddatas = dataRows.map((row) => ({
    "S.NO": row.sno,
    "Legal Name":row.firstName,
    "Display Name":row.displayName,
    "Email": row.email,
    "Secondary Email": row.secondaryEmail,    
    "Mobile": row.mobile,
    "Status": row.status
  })); 
  
  const columns = [
    {
      field: "sno",
      headerName: "S.No",
      flex:0.5,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        return (
          <>
            <div className={classes.lightText}>
              <Typography variant="body2">{params?.row?.sno}</Typography>
            </div>
          </>
        );
      },
    },
    {
      field: "firstName",
      headerName: "Legal Name",
      flex:0.7,
      sortable: true,
      renderCell: (params) => {
        return (
          <>
            <div>
              <Typography variant="body2">{params?.row?.firstName}</Typography>
            </div>
          </>
        );
      },
    },
    {
      field: "displayName",
      headerName: "Display Name",
      flex:1,
      sortable: true,
      renderCell: (params) => {
        return (
          <>
            <div>
              <Typography variant="body2">{params?.row?.displayName}</Typography>
            </div>
          </>
        );
      },
    },
    {
      field: "email",
      headerName: "Email",
      flex:1,
      sortable: true,
      renderCell: (params) => {
        return (
          <>
            <div>
              <Typography variant="body2">{params?.row?.email}</Typography>
            </div>
          </>
        );
      },
    },
    {
      field: "secondaryEmail",
      headerName: "Secondary Email",
      flex:1,
      sortable: true,
      renderCell: (params) => {
        return (
          <>
            <div>
              <Typography variant="body2">{params?.row?.secondaryEmail}</Typography>
            </div>
          </>
        );
      },
    },    
    {
      field: "mobile",
      headerName: "Mobile",
      flex:1,
      sortable: true,
      renderCell: (params) => {
        return (
          <>
            <div>
              <Typography variant="body2">{params?.row?.mobile}</Typography>
            </div>
          </>
        );
      },
    },
    {
      field: "panNumber",
      headerName: "Pan Number",
      flex:1,
      sortable: true,
      renderCell: (params) => {
        return (
          <>
            <div>
              <Typography variant="body2">{params?.row?.panNumber}</Typography>
            </div>
          </>
        );
      },
    },    
    {
      field: "status",
      headerName: "Status",
      flex:1,
      sortable: true,
      renderCell: (params) => {
        return (
          <>
            <div>
              <Typography variant="body2" className={classes.statuscolumn} 
              sx={{ background:params?.row?.background}}>{params?.row?.status}</Typography>
            </div>
          </>
        );
      },
    },
    {
      field: "documentsServiceType",
      headerName: "Documents / Service Type",
      minWidth: 230,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        const rowData = params?.row?.row || params?.row;
        return (
          <div className={classes.iconsWrapper}>
            <Button
              variant="contained"
              startIcon={<DescriptionOutlined />}
              onClick={() => handleOpenCorporateModal(rowData)}
              sx={{
                minWidth: "180px",
                borderRadius: "8px",
                px: 2,
                py: 0.9,
                fontWeight: 700,
                backgroundColor: `${params?.row?.documentsServiceTypeBackground || "#FB8C00"} !important`,
                color: "#fff !important",
                boxShadow: "0 3px 8px rgba(0,0,0,0.2)",
                "& .MuiSvgIcon-root": { color: "#fff !important" },
                "&:hover": {
                  backgroundColor: `${params?.row?.documentsServiceTypeBackground || "#FB8C00"} !important`,
                  opacity: 0.95,
                },
              }}
            >
              {params?.row?.documentsServiceType}
            </Button>
          </div>
        );
      },
    },
    {
      field: "delete",
      headerName: "Delete",
      minWidth: 110,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        const rowData = params?.row?.row || params?.row;
        return (
          <Button
            variant="contained"
            sx={{
              minWidth: "52px",
              height: "46px",
              backgroundColor: "#FDECEF !important",
              border: "1px solid #F3CBD4",
              borderRadius: "8px",
              boxShadow: "0 2px 6px rgba(0,0,0,0.12)",
              "& .MuiSvgIcon-root": { color: "#FF2B78 !important", fontSize: 24 },
              "&:hover": { backgroundColor: "#FDECEF !important", opacity: 0.95 },
            }}
            onClick={() => handleOpenDeleteCorporateModal(rowData)}
          >
            <DeleteOutline />
          </Button>
        );
      },
    }
  ];

  return (
    <>
      <Grid container className={classes.root}>
      <Grid item xs={1} md={1} lg={1} xl={1} className={classes.funBtn}>
          <Button variant="contained" startIcon={<ContentCopyOutlined />} onClick={handleCopy}>
            COPY
          </Button>
        </Grid>
        <Grid item xs={1} md={1} lg={1} xl={1} className={classes.funBtn}>
          <Button variant="contained" startIcon={<TableChartOutlined />} onClick={handleDownloadExcel}>
            EXCEL
          </Button>
        </Grid>
        <Grid item xs={1} md={1} lg={1} xl={1} className={classes.funBtn}>
          <Button variant="contained" startIcon={<DescriptionOutlined />} onClick={handleDownloadCSV}>
            CSV
          </Button>
        </Grid>
        <Grid item xs={1} md={1} lg={1} xl={1} className={classes.funBtn}>
          <Button variant="contained" startIcon={<PictureAsPdfOutlined />} onClick={handleDownloadPDF}>
            PDF
          </Button>
        </Grid>
<Grid item xs={2} md={2} lg={2} xl={2} className={classes.funBtn}>
                      {/* <Button variant="contained" startIcon={<FileDownloadOutlined />} onClick={handleDownloadAll}>
                      Download ALL
                      </Button> */}
                      </Grid>        
        <Grid item xs={6} md={6} lg={6} xl={6} className={classes.addBtn}>
          <Button variant="contained" onClick={handleOpenAddCorporateModal}>
            Add Corporate
          </Button>
        </Grid>
        <Grid item xs={12}>
          <section className={classes.dataGridTable}>
            <DataGrid
              getRowId={(row) => row?.row?._id}
              rows={dataRows}
              columns={columns}
              pageSize={pageSize}
              onPageSizeChange={(newPageSize) => {
                setPageSize(newPageSize);
                setPage(1);
              }}
              onPageChange={(newPage) => handlePageChange(newPage)}
              rowsPerPageOptions={[5, 10, 25, 50]}
              pagination
              autoHeight={true}
              disableSelectionOnClick
              scrollbarSize={4}
              rowHeight={70}
              style={{ padding: "10px", borderRadius: "0px" }}
              paginationMode="server"
              rowCount={totalPages}
            />
          </section>
        </Grid>
      </Grid>
      <CorporateAddModal
        openDialog={addCorporateModal}
        handleClose={handleCloseAddCorporateModal}
      ></CorporateAddModal>
      <CorporateUpdateModal
        openDialog={updateCorporateModal}
        id={customerId}
        handleClose={handleCloseCorporateModal}
      ></CorporateUpdateModal>
      <CorporateDeleteDialog
      openDialog={deleteCorporateModal}
      id={customerId}
      handleClose={handleCloseDeleteCorporateModal}
    ></CorporateDeleteDialog>
    </>
  );
};

export default Corporate;
